/* tslint:disable */
/* eslint-disable */
/**
 * Hermes Console
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * logoutレスポンス
 * @export
 * @interface LogoutResponse
 */
export interface LogoutResponse {
    /**
     * 
     * @type {string}
     * @memberof LogoutResponse
     */
    responseMessage?: string;
}

export function LogoutResponseFromJSON(json: any): LogoutResponse {
    return LogoutResponseFromJSONTyped(json, false);
}

export function LogoutResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): LogoutResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'responseMessage': !exists(json, 'response_message') ? undefined : json['response_message'],
    };
}

export function LogoutResponseToJSON(value?: LogoutResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'response_message': value.responseMessage,
    };
}


